


export class RecommendLotsView {
    constructor() {

        this.headerContainer = document.querySelector('.recommendations.header div.ul');
        this.footerContainer = document.querySelector('.recommendations.footer div.ul');

        this.template = document.getElementById('promo-lot-template');
    }

    render(state) { 

        if (!(state && Object.keys(state).length > 0)) { return;}

        const data = state.data;
        data.models.forEach((lot, index) => {

            const liHeader = this.getNextEmptyElement(this.headerContainer);
            const headerElement = this.renderPartial(lot);

            if (liHeader instanceof Element) { 
                liHeader.replaceWith(headerElement);
            } else {
                this.headerContainer.appendChild(headerElement);
            }

            const liFooter = this.getNextEmptyElement(this.footerContainer);
            const footerElement = this.renderPartial(lot);

            if (liFooter instanceof Element) { 
                liFooter.replaceWith(footerElement);
            } else {
                this.footerContainer.appendChild(footerElement);
            }
        });

        if (data.models.length) {

            const headerContainer = this.headerContainer.querySelector('.w_dummies');
            if (headerContainer) { headerContainer.classList.remove('w_dummies');}

            const footerContainer = this.footerContainer.querySelector('.w_dummies');
            if (footerContainer) { footerContainer.classList.remove('w_dummies');}

            this.headerContainer
                .querySelectorAll('div.li')
                .forEach(el => {
                    if (el.querySelector('.dummy')) { el.remove(); }
                });

            this.footerContainer
                .querySelectorAll('div.li')
                .forEach(el => {
                    if (el.querySelector('.dummy')) { el.remove(); }
                });
        }
    }

    renderPartial(data) {

        const clone = this.template.content.cloneNode(true);
        const liDiv = clone.firstElementChild;

        if (liDiv) {

            liDiv.classList.remove('dummy');

            if (data.isExplicit) { liDiv.classList.add('censored');}

            const innerDummy = liDiv.querySelector('.dummy');
            if (innerDummy) { innerDummy.classList.remove('dummy');}

            const previewLink = liDiv.querySelector('.preview');
            if (previewLink) { previewLink.href = data.url;}

            const img = liDiv.querySelector('img');
            if (img) {

                img.src = data.preview;
                img.dataset.src = data.preview;
                img.alt = data.title;
            }

            const titleLink = liDiv.querySelector('.title');
            if (titleLink) { 
                titleLink.href = data.url;
                titleLink.textContent = data.title;
            }

            const currentEl = liDiv.querySelector('.current');
            const priceEl = currentEl?.querySelector('p');
            if (currentEl && priceEl) {
                priceEl.textContent = data.price;
                priceEl.insertAdjacentText('afterend', ' ' + data.currency.title);
            }
        }
        return liDiv;
    }

    getNextEmptyElement(container) { 
        const dummyChild = container.querySelector('div.li .dummy');
        return dummyChild ? dummyChild.closest('div.li') : null;
    }
}